module.exports = ".content {\n  margin-left: 2%;\n  padding-top: 83px;\n  position: absolute;\n  height: 200%;\n  width: 78%;\n  top: 0;\n  left: 20%;\n  overflow: auto;\n  z-index: -1; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/content/content.component.scss
// module id = ./src/app/content/content.component.scss
// module chunks = main